export enum Roles {
  FachlicheHotline = "Fachliche_Hotline",
  LinkAdmin = "LINK_Admin",
  LinkAgent = "LINK_Agent",
  LinkAgentPlus = "LINK_Agent_Plus",
  LinkPL = "LINK_PL",
  LinkFeldleitung = "LINK_Feldleitung",
  AgroscopePL = "Agroscope_PL",
  LinkITOperations = "LINK_IT_Operations",
}

export interface UserData {
  acr: string;
  aio: string;
  amr: string[];
  appid: string;
  appidacr: string;
  aud: string;
  email: string;
  exp: number;
  family_name: string;
  given_name: string;
  iat: number;
  idp: string;
  ipaddr: string;
  iss: string;
  name: string;
  nbf: number;
  oid: string;
  rh: string;
  roles: string[];
  scp: string;
  sub: string;
  tid: string;
  unique_name: string;
  uti: string;
  ver: string;
}
